import EventEmitter3 from 'eventemitter3';
import { UtilService } from './utils';

export class EventEmitter extends EventEmitter3.EventEmitter {

    on<T extends string | symbol>(event: T, fn: (...args: any[]) => void, debounce?:number): this {
        const tempFn = debounce ? (...args: any[]) => {
            UtilService.debounce(fn, debounce)(...args)
        } : fn;
        return super.on(event, tempFn);
    }

}
